export interface CountryPhoneLengthRule {
  min: number;
  max: number;
}

export const COUNTRY_LOCAL_PHONE_LENGTH: Record<
  string,
  CountryPhoneLengthRule
> = {
  AD: { min: 6, max: 9 },
  AE: { min: 9, max: 9 },
  AF: { min: 9, max: 9 },
  AG: { min: 10, max: 10 },
  AI: { min: 10, max: 10 },
  AL: { min: 9, max: 9 },
  AM: { min: 8, max: 8 },
  AN: { min: 10, max: 10 },
  AO: { min: 9, max: 9 },
  AQ: { min: 10, max: 10 },
  AR: { min: 10, max: 11 },
  AS: { min: 10, max: 10 },
  AT: { min: 7, max: 13 },
  AU: { min: 5, max: 12 },
  AW: { min: 7, max: 7 },
  AX: { min: 5, max: 12 },
  AZ: { min: 9, max: 9 },
  BA: { min: 8, max: 9 },
  BB: { min: 10, max: 10 },
  BD: { min: 10, max: 10 },
  BE: { min: 9, max: 9 },
  BF: { min: 8, max: 8 },
  BG: { min: 8, max: 9 },
  BH: { min: 8, max: 8 },
  BI: { min: 8, max: 8 },
  BJ: { min: 10, max: 10 },
  BM: { min: 10, max: 10 },
  BN: { min: 7, max: 7 },
  BO: { min: 8, max: 8 },
  BR: { min: 10, max: 11 },
  BS: { min: 10, max: 10 },
  BT: { min: 8, max: 8 },
  BV: { min: 10, max: 10 },
  BW: { min: 8, max: 8 },
  BY: { min: 6, max: 11 },
  BZ: { min: 7, max: 7 },
  CA: { min: 10, max: 10 },
  CC: { min: 6, max: 12 },
  CD: { min: 7, max: 9 },
  CF: { min: 8, max: 8 },
  CG: { min: 9, max: 9 },
  CH: { min: 9, max: 9 },
  CI: { min: 10, max: 10 },
  CK: { min: 5, max: 5 },
  CL: { min: 9, max: 9 },
  CM: { min: 9, max: 9 },
  CN: { min: 7, max: 12 },
  CO: { min: 10, max: 10 },
  CR: { min: 8, max: 8 },
  CS: { min: 10, max: 10 },
  CU: { min: 8, max: 8 },
  CV: { min: 7, max: 7 },
  CX: { min: 6, max: 12 },
  CY: { min: 8, max: 8 },
  CZ: { min: 9, max: 9 },
  DE: { min: 10, max: 11 },
  DJ: { min: 8, max: 8 },
  DK: { min: 8, max: 8 },
  DM: { min: 10, max: 10 },
  DO: { min: 10, max: 10 },
  DZ: { min: 9, max: 9 },
  EC: { min: 9, max: 9 },
  EE: { min: 7, max: 8 },
  EG: { min: 10, max: 10 },
  EH: { min: 9, max: 9 },
  ER: { min: 7, max: 7 },
  ES: { min: 9, max: 9 },
  ET: { min: 9, max: 9 },
  FI: { min: 5, max: 12 },
  FJ: { min: 7, max: 11 },
  FK: { min: 5, max: 5 },
  FM: { min: 7, max: 7 },
  FO: { min: 6, max: 6 },
  FR: { min: 9, max: 9 },
  GA: { min: 7, max: 8 },
  GB: { min: 7, max: 10 },
  GD: { min: 10, max: 10 },
  GE: { min: 9, max: 9 },
  GF: { min: 9, max: 9 },
  GG: { min: 10, max: 10 },
  GH: { min: 9, max: 9 },
  GI: { min: 8, max: 8 },
  GL: { min: 6, max: 6 },
  GM: { min: 7, max: 7 },
  GN: { min: 9, max: 9 },
  GP: { min: 9, max: 9 },
  GQ: { min: 9, max: 9 },
  GR: { min: 10, max: 10 },
  GS: { min: 10, max: 10 },
  GT: { min: 8, max: 8 },
  GU: { min: 10, max: 10 },
  GW: { min: 9, max: 9 },
  GY: { min: 7, max: 7 },
  HK: { min: 5, max: 11 },
  HM: { min: 10, max: 10 },
  HN: { min: 8, max: 8 },
  HR: { min: 8, max: 9 },
  HT: { min: 8, max: 8 },
  HU: { min: 9, max: 9 },
  ID: { min: 9, max: 12 },
  IE: { min: 9, max: 9 },
  IL: { min: 9, max: 9 },
  IM: { min: 10, max: 10 },
  IN: { min: 10, max: 10 },
  IO: { min: 7, max: 7 },
  IQ: { min: 10, max: 10 },
  IR: { min: 10, max: 10 },
  IS: { min: 7, max: 9 },
  IT: { min: 9, max: 10 },
  JE: { min: 10, max: 10 },
  JM: { min: 10, max: 10 },
  JO: { min: 9, max: 9 },
  JP: { min: 10, max: 10 },
  KE: { min: 9, max: 9 },
  KG: { min: 9, max: 9 },
  KH: { min: 8, max: 9 },
  KI: { min: 8, max: 8 },
  KM: { min: 7, max: 7 },
  KN: { min: 10, max: 10 },
  KP: { min: 10, max: 10 },
  KR: { min: 9, max: 10 },
  KW: { min: 8, max: 8 },
  KY: { min: 10, max: 10 },
  KZ: { min: 10, max: 14 },
  LA: { min: 9, max: 10 },
  LB: { min: 7, max: 8 },
  LC: { min: 10, max: 10 },
  LI: { min: 7, max: 9 },
  LK: { min: 9, max: 9 },
  LR: { min: 7, max: 9 },
  LS: { min: 8, max: 8 },
  LT: { min: 8, max: 8 },
  LU: { min: 9, max: 9 },
  LV: { min: 8, max: 8 },
  LY: { min: 9, max: 9 },
  MA: { min: 9, max: 9 },
  MC: { min: 8, max: 9 },
  MD: { min: 8, max: 8 },
  MG: { min: 9, max: 9 },
  MH: { min: 7, max: 7 },
  MK: { min: 8, max: 8 },
  ML: { min: 8, max: 8 },
  MM: { min: 7, max: 10 },
  MN: { min: 8, max: 8 },
  MO: { min: 8, max: 8 },
  MP: { min: 10, max: 10 },
  MQ: { min: 9, max: 9 },
  MR: { min: 8, max: 8 },
  MS: { min: 10, max: 10 },
  MT: { min: 8, max: 8 },
  MU: { min: 7, max: 10 },
  MV: { min: 7, max: 10 },
  MW: { min: 9, max: 9 },
  MX: { min: 10, max: 10 },
  MY: { min: 9, max: 10 },
  MZ: { min: 9, max: 9 },
  NA: { min: 9, max: 9 },
  NC: { min: 6, max: 6 },
  NE: { min: 8, max: 8 },
  NF: { min: 6, max: 6 },
  NG: { min: 10, max: 10 },
  NI: { min: 8, max: 8 },
  NL: { min: 9, max: 11 },
  NO: { min: 8, max: 8 },
  NP: { min: 10, max: 10 },
  NR: { min: 7, max: 7 },
  NU: { min: 4, max: 7 },
  NZ: { min: 5, max: 10 },
  OM: { min: 8, max: 8 },
  PA: { min: 7, max: 8 },
  PE: { min: 8, max: 9 },
  PF: { min: 8, max: 8 },
  PG: { min: 7, max: 8 },
  PH: { min: 10, max: 10 },
  PK: { min: 10, max: 10 },
  PL: { min: 9, max: 9 },
  PM: { min: 6, max: 9 },
  PN: { min: 10, max: 10 },
  PR: { min: 10, max: 10 },
  PS: { min: 9, max: 9 },
  PT: { min: 9, max: 9 },
  PW: { min: 7, max: 7 },
  PY: { min: 9, max: 9 },
  QA: { min: 8, max: 8 },
  RE: { min: 9, max: 9 },
  RO: { min: 6, max: 9 },
  RU: { min: 10, max: 14 },
  RW: { min: 9, max: 9 },
  SA: { min: 9, max: 9 },
  SB: { min: 5, max: 7 },
  SC: { min: 7, max: 7 },
  SD: { min: 9, max: 9 },
  SE: { min: 9, max: 9 },
  SG: { min: 8, max: 8 },
  SH: { min: 5, max: 5 },
  SI: { min: 5, max: 8 },
  SJ: { min: 8, max: 8 },
  SK: { min: 9, max: 9 },
  SL: { min: 8, max: 8 },
  SM: { min: 8, max: 8 },
  SN: { min: 9, max: 9 },
  SO: { min: 7, max: 9 },
  SR: { min: 7, max: 7 },
  ST: { min: 7, max: 7 },
  SV: { min: 8, max: 8 },
  SY: { min: 9, max: 9 },
  SZ: { min: 8, max: 8 },
  TC: { min: 10, max: 10 },
  TD: { min: 8, max: 8 },
  TF: { min: 10, max: 10 },
  TG: { min: 8, max: 8 },
  TH: { min: 9, max: 9 },
  TJ: { min: 9, max: 9 },
  TK: { min: 4, max: 7 },
  TL: { min: 8, max: 8 },
  TM: { min: 8, max: 8 },
  TN: { min: 8, max: 8 },
  TO: { min: 7, max: 7 },
  TR: { min: 10, max: 10 },
  TT: { min: 10, max: 10 },
  TV: { min: 6, max: 7 },
  TW: { min: 7, max: 11 },
  TZ: { min: 9, max: 9 },
  UA: { min: 9, max: 10 },
  UG: { min: 9, max: 9 },
  UM: { min: 10, max: 10 },
  US: { min: 10, max: 10 },
  UY: { min: 4, max: 13 },
  UZ: { min: 9, max: 9 },
  VA: { min: 9, max: 10 },
  VC: { min: 10, max: 10 },
  VE: { min: 10, max: 10 },
  VG: { min: 10, max: 10 },
  VI: { min: 10, max: 10 },
  VN: { min: 9, max: 9 },
  VU: { min: 7, max: 7 },
  WF: { min: 6, max: 6 },
  WS: { min: 7, max: 10 },
  YE: { min: 9, max: 9 },
  YT: { min: 9, max: 9 },
  ZA: { min: 5, max: 9 },
  ZM: { min: 9, max: 9 },
  ZW: { min: 9, max: 9 },
};

export function getCountryPhoneLengthRule(
  countryCode: string,
): CountryPhoneLengthRule {
  return (
    COUNTRY_LOCAL_PHONE_LENGTH[countryCode?.toUpperCase()] ?? {
      min: 10,
      max: 10,
    }
  );
}

export function getLocalPhoneNumberMaxLength(countryCode: string): number {
  return getCountryPhoneLengthRule(countryCode).max;
}

export function getCountryFlag(countryCode: string): string {
  if (!countryCode || countryCode.length !== 2) {
    return '';
  }

  return countryCode
    .toUpperCase()
    .split('')
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('');
}

export function sanitizeLocalPhoneDigits(
  value: unknown,
  countryCode: string,
): string {
  const max = getCountryPhoneLengthRule(countryCode).max;
  return String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, max);
}
